import { fetch } from './fetch';

export async function fetchFile(url: string, config: any) {
    const response = await fetch(url, config);
    const file: Blob = new Blob([await response.blob()], { type: 'application/pdf' });
    const fileURL: string = URL.createObjectURL(file);
    return fileURL;
}
